import { render } from "./BtnRelated.vue?vue&type=template&id=57925c23"
import script from "./BtnRelated.vue?vue&type=script&lang=js"
export * from "./BtnRelated.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__